// extracted by mini-css-extract-plugin
export default {"wrap":"MealsComponent_wrap__Snc3i","btnBlock":"MealsComponent_btnBlock__jGs6U","listBlock":"MealsComponent_listBlock__pWaX-"};